import React, {Component} from "react";
import {Image} from "react-bootstrap";
import FullProfileModalBase from "../FullProfileModalBase";

class PlayerAssistInformation extends FullProfileModalBase {
    render = () => {
        const {name, avatar, duration} = this.props;

        return (
            <div className="player-assist-information">
                <Image className="avatar" src={avatar}/>
                <div className="name"> {name} </div>
            </div>
        );
    };
}

export default PlayerAssistInformation;
